import { findFilenames, getUserData } from "./API"

export function shouldSoundOutPhonemes(wordMetadata){
    if(!wordMetadata) return false
    if(wordMetadata.NPHON && wordMetadata.NPHON <= 5) return true
    return false
}

export function withLanguageSelection({bilingual, english}){
    if(getUserData().bilingualMode){
        bilingual()
    }else{
        english()
    }
}